/* eslint-disable @reatom/unit-naming-rule */
import { action, spawn } from '@reatom/framework'

import { Result } from '@blade/std-lib'
import { reatomRequest } from '@root/shared/lib'
import { showErrorSnackbarAction } from '@root/shared/ui'

import { supportTicketsModel } from './reatom-support-ticket'
import { createSupportTicketRequestAction } from './support-requests'

import type { SupportTicketsCreatePayload } from '@blade/trade-api-client'

export const reatomCreateSupportTicket = () => {
  const execAction = action(
    async (ctx, payload: SupportTicketsCreatePayload) => {
      const result = await ctx.schedule(() =>
        createSupportTicketRequestAction(ctx, payload),
      )

      if (Result.isSuccess(result)) {
        spawn(ctx, (ctx) => {
          supportTicketsModel.run(ctx)
        })
      } else {
        showErrorSnackbarAction(ctx, result.failure)
      }

      return result
    },
  )

  const state = reatomRequest({
    execAction,
  })

  return state
}
